import { usePostClientLogsHook } from "api-client";

type LoggerProps = {
  log?: string;
  errorType?: string;
  timestamp?: string;
  errorCode?: string;
  errorMessage?: string;
};

export const logger = ({
  log,
  errorType,
  timestamp,
  errorCode,
  errorMessage,
}: LoggerProps) => {
  console.log(`${log} ${errorCode} ${errorType} ${errorMessage} ${timestamp}`);

  const postClientLogs = usePostClientLogsHook();

  postClientLogs({
    log,
    errorType,
    timestamp,
    errorCode,
    errorMessage,
  });
}
